exports = module.exports = require("../../../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Buttons-module__wrapper___25fWR{margin-top:2rem;display:grid;grid-auto-flow:column;gap:.5rem;justify-content:end}", ""]);

// exports
exports.locals = {
	"wrapper": "Buttons-module__wrapper___25fWR"
};